import { TableCell, TableHead, TableRow } from '@material-ui/core';

import { Font, FontProps } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { TableColumn } from '@/config/types';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';
import { DefaultTableProps } from '@/types/defaultTableProps';

interface HeaderProps {
  tableProps: Omit<DefaultTableProps, 'isScrollable'>;
  columns: TableColumn[];
  fontProps?: Partial<FontProps>;
}

export const CustomHeader = ({ tableProps, columns, fontProps }: HeaderProps) => {
  const { isMobile } = useScreen();
  const { classes, stickyCellStyle } = tableProps;
  const { background } = useCustomTheme();

  return (
    <TableHead className={classes.root}>
      <TableRow>
        {columns.map((column) => (
          <TableCell
            key={column.name}
            align={column.align}
            width={column.colWidth ?? 'auto'}
            style={column.sticky && isMobile ? { ...stickyCellStyle, backgroundColor: background } : {}}
          >
            <Font variant={'body2'} className="overflow-text-ellipsis" color={'textSecondary'} {...fontProps}>
              <Text strong tId={column.label} />
            </Font>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
